<div id="footer" class='textAlign' [class.home-dashboard-view]="homeDashboard">
  <span>
    iRebal® is a technology offering of Schwab. Schwab does not provide investment or tax advice. © {{now  | date: 'yyyy'}} Charles Schwab & Co., Inc. ("Schwab") All rights reserved. Member
    <a target="_blank" href="http://www.sipc.org/">SIPC</a>
  </span>
  @if (showMMCDisclaimerLink && MMC_ADVISOR) {
    <span style="padding-left: 15px;">
      <a (click)="showMMCFooterDialog()">Model Market Center Disclaimer</a>
      <a class="footer-mmc-adv-link" style="padding-left:15px;"
      href="https://www.schwab.com/resource/Schwab-model-market-center" target="_blank" (click)="download_adv()">Disclosure Brochure</a>
    </span>
  }
</div>
